var map = {
	"./announcement.svg": 907,
	"./approved-partner.svg": 908,
	"./attachments.svg": 909,
	"./confidence.svg": 910,
	"./continents.svg": 911,
	"./customer-benefits.svg": 912,
	"./experience.svg": 913,
	"./footer.svg": 914,
	"./home.svg": 915,
	"./hotsales.svg": 916,
	"./icons.svg": 917,
	"./invitation.svg": 918,
	"./landing-features.svg": 919,
	"./landing.svg": 920,
	"./local-exclusive.svg": 921,
	"./local-flex.svg": 922,
	"./local-rewards.svg": 923,
	"./payments.svg": 924,
	"./profile.svg": 925,
	"./reservation.svg": 926,
	"./review.svg": 927,
	"./search.svg": 928,
	"./static-pages.svg": 929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 906;